import { useAccountContext } from 'src/components/account/context'
import CloseIcon from 'src/images/icons/CloseIcon'

import CashbackBalance from '../../CashbackBalance/CashbackBalance'
import LoggedInContent from './LoggedInContent'
import LoggedOutContent from './LoggedOutContent'

type LoginDropdownProps = {
  className?: string
  onClose?: () => void
}

const LoginDropdown = ({ className = '', onClose }: LoginDropdownProps) => {
  const { isLoggedIn } = useAccountContext()

  return (
    <div className={className} data-testid="login-dropdown">
      <div className="relative">
        <CashbackBalance variant="home" />
        <button
          className="restructure-tablet:hidden absolute top-1/2 transform -translate-y-1/2 right-6"
          onClick={() => {
            onClose?.()
          }}
        >
          <CloseIcon fill="#FFF" />
        </button>
      </div>

      <div className="px-6 py-4 restructure-maxMobile:pb-10">
        {isLoggedIn ? <LoggedInContent /> : <LoggedOutContent />}
      </div>
    </div>
  )
}

export default LoginDropdown
